"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resize;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Url = _interopRequireDefault(require("urlinator/Url"));

var _file = require("FileManagerCore/utils/file");

function filterParams(params) {
  var filteredParams = {};
  var validKeys = ['width', 'height', 'upscale', 'upsize', 'length', 'quality'];
  validKeys.forEach(function (key) {
    if (params[key]) {
      filteredParams[key] = params[key];
    }
  });
  return filteredParams;
}
/**
 * Transforms FM urls to structure needed to route to image resizing service
 * and appends resize query params
 *
 * @param {string} url
 * @param {object} params
 */


function resize(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parsed = new _Url.default(url);
  var pathSegments = parsed.pathname.split('/');
  var hubfsSegment = pathSegments.indexOf('hubfs'); // url is not a file manager url, so return

  if (hubfsSegment < 0) {
    return url;
  }

  var updatedParams = (0, _extends2.default)({}, parsed.params, filterParams(params));

  if ((0, _file.isCdn)(parsed.hostname) && pathSegments.indexOf('hub') < 0) {
    var pathSuffix = pathSegments.slice(3).join('/');
    var hubId = parseInt(pathSegments[hubfsSegment + 1], 10);

    if (!hubId) {
      return url;
    }

    parsed.update({
      pathname: "/hub/" + hubId + "/hubfs/" + pathSuffix,
      params: updatedParams
    });
  } else if (pathSegments[1] === 'hubfs') {
    var _pathSuffix = pathSegments.slice(2).join('/');

    parsed.update({
      pathname: "/hs-fs/hubfs/" + _pathSuffix,
      params: updatedParams
    });
  } else {
    parsed.update({
      params: updatedParams
    });
  }

  return parsed.href;
}

module.exports = exports.default;